import {
  GET_QUERY_TEMPLATES,
  GET_QUERY_TEMPLATE,
  CREATE_QUERY_TEMPLATE,
  UPDATE_QUERY_TEMPLATE,
  DELETE_QUERY_TEMPLATES,
  GETTING_QUERY_TEMPLATES,
  GETTING_QUERY_TEMPLATE,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE,
  CREATING_QUERY_TEMPLATE,
  UPDATING_QUERY_TEMPLATE,
  DELETING_QUERY_TEMPLATES,
  GETTING_QUERY_TEMPLATE_SUCCEEDED,
  CREATING_QUERY_TEMPLATE_SUCCEEDED,
  UPDATING_QUERY_TEMPLATE_SUCCEEDED,
  DELETING_QUERY_TEMPLATES_SUCCEEDED,
  GETTING_QUERY_TEMPLATES_SUCCEEDED,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_SUCCEEDED,
  GETTING_QUERY_TEMPLATES_FAILED,
  GETTING_QUERY_TEMPLATE_FAILED,
  CREATING_QUERY_TEMPLATE_FAILED,
  UPDATING_QUERY_TEMPLATE_FAILED,
  DELETING_QUERY_TEMPLATES_FAILED,
  SET_CURRENT_QUERY_TEMPLATE,
  UNSET_CURRENT_QUERY_TEMPLATE,
  CLEAR_QUERY_TEMPLATE_ERROR,
  CLEAR_QUERY_TEMPLATE_STORE,
  SET_NEXT_STEP,
  UNSET_NEXT_STEP,
  GET_PAGINATED_QUERY_TEMPLATES,
  GETTING_PAGINATED_QUERY_TEMPLATES,
  GETTING_PAGINATED_QUERY_TEMPLATES_SUCCEEDED,
  GETTING_PAGINATED_QUERY_TEMPLATES_FAILED,
  GET_MINIMAL_QUERY_TEMPLATES,
  GETTING_MINIMAL_QUERY_TEMPLATES,
  GETTING_MINIMAL_QUERY_TEMPLATES_SUCCEEDED,
  GETTING_MINIMAL_QUERY_TEMPLATES_FAILED,
  SET_COPY_CURRENT_QUERY_TEMPLATE,
  GET_RECIPIENT_COUNT_REQUEST_ID,
  GETTING_RECIPIENT_COUNT_REQUEST_ID_SUCCEEDED,
  GETTING_RECIPIENT_COUNT_REQUEST_ID_FAILED,
  GET_LISTS_RECIPIENT_COUNT,
  GETTING_LISTS_RECIPIENT_COUNT_SUCCEEDED,
  GETTING_LISTS_RECIPIENT_COUNT_FAILED,
  END_POLLING,
  RESET_LIST_RECIPIENT_COUNT,
  GETTING_RECIPIENT_DETAILS_SUCCEEDED,
  GET_RECIPIENT_DETAILS,
  GETTING_RECIPIENT_DETAILS_FAILED,
  UPDATE_RECIPIENT_QUERY_FILTERS,
  RESET_RECIPIENT_QUERY_FILTERS
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import sortBy from 'lodash.sortby';
import { produce } from 'immer';
import { ProductType } from 'constants.js';
import { mapExpressionFromResposne } from 'store/helpers';

const deCamelizer = str => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/([0-9]+)/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
};

const initialState = {
  getting: false,
  gettingPaginated: true,
  gettingMinimal: false,
  creating: false,
  creatingPaginated: false,
  updating: false,
  deleting: false,
  deletingPaginated: false,
  list: [],
  paginatedList: [],
  minimalList: [],
  minimalTotalRecords: 0,
  current: {
    type: '',
    name: '',
    _campaignOccurrenceType: 'ON_DEMAND',
    conditionExpression: [],
    productType: ProductType.Product
  },
  error: {
    message: null,
    raw: null
  },
  isInTemplateDesignDialog: false,
  isTemplateSaving: false,
  isTemplateSaved: false,
  filters: {
    pageNo: 0,
    searchInput: '',
    sortBy: 'name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    totalCount: 0,
    displayActive: true,
    filterTemplates: [],
    filterProductNames: [],
    filterProductCategories: []
  },
  listsCount: {
    requestId: null,
    isPolling: false,
    startPolling: false,
    endPolling: false,
    pollingFailed: false,
    count: 0
  },
  recipientDetails: {
    isLoading: false,
    details: [],
    count: 0
  }
};

export default createReducer(initialState, {
  [GET_QUERY_TEMPLATES]: state => {
    return state;
  },

  [GET_PAGINATED_QUERY_TEMPLATES]: state => {
    return state;
  },

  [GETTING_PAGINATED_QUERY_TEMPLATES]: state => {
    state.gettingPaginated = true;
    return state;
  },

  [GETTING_PAGINATED_QUERY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload.map(template => ({
      ...template
    }));
    return state;
  },

  [GETTING_PAGINATED_QUERY_TEMPLATES_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.creatingPaginated = false;
    state.deletingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [GETTING_MINIMAL_QUERY_TEMPLATES]: state => {
    state.gettingMinimal = true;
    return state;
  },

  [GETTING_MINIMAL_QUERY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingMinimal = false;
    state.minimalList = action.payload.data || [];
    state.minimalTotalRecords = action.payload.totalRecords || 0;
    return state;
  },

  [GETTING_MINIMAL_QUERY_TEMPLATES_FAILED]: (state, action) => {
    state.gettingMinimal = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [GET_QUERY_TEMPLATE]: state => {
    return state;
  },

  [CREATE_QUERY_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [UPDATE_QUERY_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [DELETE_QUERY_TEMPLATES]: (state, action) => {
    return state;
  },
  [GETTING_QUERY_TEMPLATES]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_QUERY_TEMPLATE]: state => {
    state.getting = true;
    state.recipientDetails.isLoading = true;
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE]: state => {
    state.getting = true;
    return state;
  },
  [CREATING_QUERY_TEMPLATE]: state => {
    state.creating = true;
    state.current = {
      ...state.current,
      active: state.current.active === undefined ? true : state.current.active
    };
    return state;
  },
  [UPDATING_QUERY_TEMPLATE]: state => {
    state.updating = true;
    return state;
  },
  [DELETING_QUERY_TEMPLATES]: state => {
    state.deleting = true;
    return state;
  },
  [GETTING_QUERY_TEMPLATE_SUCCEEDED]: (state, action) => {
    const { template, eventMetaData = [] } = action.payload;

    let hydratedEventMetaData = sortBy(
      eventMetaData.map(data => ({
        ...data,
        productName: data.schemaType === 'EVENT'
          ? `Event Product - ${template.productName}`
          : data.schemaType === 'ENRICHMENT' ? `Enrichment Product - ${data.enrichmentProduct}` : data.schemaTypeDisplayName,
        schemaConditionAttributes: data.schemaConditionAttributes
          .map(a => ({
            key: a.conditionAttribute,
            name:
              !a.displayName || a.displayName === ''
                ? deCamelizer(a.conditionAttribute)
                : a.displayName,
            dataType: a.conditionAttributeType || a.attributeFieldType,
            text: `{{${a.conditionAttribute}}}`,
            attributeFieldType: a.attributeFieldType,
            metaAttribute: a.metaAttribute,
            description: a.description,
            productName: data.schemaType === 'EVENT'
              ? `Event Product - ${template.productName}`
              : data.schemaType === 'ENRICHMENT' ? `Enrichment Product - ${data.enrichmentProduct}` : data.schemaTypeDisplayName,
              subAttribute: a.subAttribute
          }))
      })).filter(data => template.productType === 'LIST' ? (data.schemaType === 'EVENT' || data.schemaType === 'ENRICHMENT' || data.schemaType === 'LIST') : data ),
      'name'
    );

    let eventFields = [];
    hydratedEventMetaData.map(data =>
      eventFields.push(...data.schemaConditionAttributes.filter(f => !f.metaAttribute).map(f => ({ ...f, schemaType: data.schemaType })).sort((a, b) => a?.name.localeCompare(b?.name)))
    );
    let updatedTemplate = produce(template, templateDraft => {
      templateDraft.eventMetaData = hydratedEventMetaData;
      templateDraft.conditionExpression = mapExpressionFromResposne(
        templateDraft?.conditionExpression || {},
        eventFields
      );
    });

    state.recipientDetails.isLoading = false;
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...updatedTemplate };
    return state;
  },
  [CREATING_QUERY_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = true;
    state.current = { ...action.payload };
    return state;
  },
  [UPDATING_QUERY_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = true;
    state.current = { ...action.payload };
    return state;
  },
  [DELETING_QUERY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.deleting = false;
    state.current = action.payload.find(uuid => uuid === state.current.uuid)
      ? {}
      : state.current;
    state.paginatedList = state.paginatedList.map(template => {
      if (template.uuid === action.payload[0]) {
        template.active = !template.active;
      }
      return template;
    });
    return state;
  },
  [GETTING_QUERY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_SUCCEEDED]: (
    state,
    action
  ) => {
    state.getting = false;
    state.current = {
      ...state.current,
      associatedCampaigns: action.payload.campaignList.find(
        campaign => campaign.uuid === state.current?.uuid
      )
    };
    state.paginatedList = state.paginatedList.map(template => {
      if (template.uuid === action.payload.uuid) {
        template.associatedCampaigns = action.payload.campaignList;
      }
      return template;
    });
    return state;
  },
  [GETTING_QUERY_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_QUERY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.recipientDetails.isLoading = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATING_QUERY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATING_QUERY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [DELETING_QUERY_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_RECIPIENT_COUNT_REQUEST_ID]: state => {
    state.listsCount.pollingFailed = false;
    return state;
  },
  [GETTING_RECIPIENT_COUNT_REQUEST_ID_SUCCEEDED]: (state, action) => {
    state.listsCount = {
      ...state.listsCount,
      requestId: action.payload.requestId,
      endPolling: true
    };
    return state;
  },
  [GETTING_RECIPIENT_COUNT_REQUEST_ID_FAILED]: state => {
    state.listsCount.pollingFailed = true;
    return state;
  },
  [GET_LISTS_RECIPIENT_COUNT]: state => {
    state.listsCount = {
      ...state.listsCount,
      endPolling: false,
      isPolling: true,
      pollingFailed: false
    };
    return state;
  },
  [GETTING_LISTS_RECIPIENT_COUNT_SUCCEEDED]: (state, action) => {
    state.listsCount = {
      ...state.listsCount,
      count: action.payload.count,
      isPolling: false,
      requestId: null
    };
    return state;
  },
  [GETTING_LISTS_RECIPIENT_COUNT_FAILED]: state => {
    state.listsCount = {
      ...state.listsCount,
      isPolling: false,
      requestId: null,
      pollingFailed: true
    };
    return state;
  },
  [END_POLLING]: state => {
    state.listsCount.endPolling = true;
    return state;
  },
  [RESET_LIST_RECIPIENT_COUNT]: state => {
    state.listsCount = {
      ...state.listsCount,
      isPolling: false,
      requestId: null,
      count: 0,
      pollingFailed: false
    };
    return state;
  },
  [SET_CURRENT_QUERY_TEMPLATE]: (state, action) => {
    state.current = {
      ...action.payload
    };
    state.listsCount = {
      ...state.listsCount,
      isPolling: false,
      pollingFailed: false,
      requestId: null
    };
    state.isTemplateSaved = false;
    return state;
  },
  [UNSET_CURRENT_QUERY_TEMPLATE]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  [CLEAR_QUERY_TEMPLATE_ERROR]: state => {
    state.error = { ...initialState.error };
    return state;
  },
  [CLEAR_QUERY_TEMPLATE_STORE]: state => {
    let updatedState = {
      ...initialState
    };
    return updatedState;
  },
  [SET_NEXT_STEP]: state => {
    state.isInTemplateDesignDialog = true;
    return state;
  },
  [UNSET_NEXT_STEP]: state => {
    state.isInTemplateDesignDialog = false;
    return state;
  },
  [SET_COPY_CURRENT_QUERY_TEMPLATE]: (state, action) => {
    state.current = action.payload;
    return state;
  },
  [GET_RECIPIENT_DETAILS]: state => {
    state.recipientDetails.isLoading = true;
    return state;
  },
  [GETTING_RECIPIENT_DETAILS_SUCCEEDED]: (state, action) => {
    state.recipientDetails = {
      isLoading: false,
      details: action.payload.data,
      count: action.payload.totalRecords
    };
    return state;
  },
  [GETTING_RECIPIENT_DETAILS_FAILED]: state => {
    state.recipientDetails = { ...initialState.recipientDetails };
    return state;
  },
  [UPDATE_RECIPIENT_QUERY_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  [RESET_RECIPIENT_QUERY_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = {
      ...initialState.filters
    };
    return state;
  }
});
